<template>
  <div class="container-fluid">
    <share-modal v-show="isBrowser" ref="shareModal"></share-modal>
    <header-box></header-box>
    <div class="main">
      <div class="banner">
        <div class="banner_box container">
          <img
            src="../../assets/images/banner_pc.png"
            class="img-responsive hidden-xs"
          />
          <img
            src="../../assets/images/banner_mobile.png"
            class="img-responsive visible-xs"
          />
          <div class="banner_info_box">
            <div class="down_box">
              <div class="btn_group hidden-xs">
                <div>
                  <div class="btn-container">
                    <button class="btn" @click="jumpAppStore">
                      <span class="icon iconfont iconIconmetro-apple"></span>
                      <span class="txt">APP Store</span>
                    </button>
                    <div class="qrcode-box">
                      <img src="@/assets/images/pc_home_img_ios.png" alt="">
                    </div>
                  </div>
                  <div class="btn-container">
                    <button class="btn" @click="jumpAndroid">
                      <span class="icon iconfont iconIconawesome-android2"></span>
                      <span class="txt">Android下载</span>
                    </button>
                    <div class="qrcode-box">
                      <img src="@/assets/images/pc_home_img_android.png" alt="">
                    </div>
                  </div>
                  <div class="btn-container">
                    <button class="btn" @click="jumpHarmonyOS">
                      <span class="icon iconfont iconhome_icon_harmonyos"></span>
                      <span class="txt">鸿蒙版下载</span>
                    </button>
                    <div class="qrcode-box">
                      <img src="@/assets/images/pc_home_img_hongmeng.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="visible-xs">
                <div class="btn-group">
                  <!-- 下载APP体验 -->
                  <template
                    v-if="curConfig.isWeiXin && !showWx && !curConfig.isWXwork"
                  >
                    <wx-open-launch-weapp
                      class="openweapp mobile-btn"
                      id="launch-btn"
                      username="gh_f00a8168566b"
                      path="pages/index/index"
                      @click="openWechat"
                      :appid="appId"
                    >
                      立即查车体验
                      <script type="text/wxtag-template">
                        <style>
                          .wx-btn {
                            height:100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 14px;
                            padding: 0;
                            background: #fff !important;
                            border: none;
                            color: #ff5c00;
                            border-radius: 1.44rem;
                            margin:auto;
                          }
                        </style>
                        <button style="padding:0" class="wx-btn" @click="openWechat">
                          立即查车体验
                        </button>
                      </script>
                    </wx-open-launch-weapp>
                  </template>
                  <button class="mobile-btn" @click="downZsgj">
                    下载APP体验
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="content">
        <li>
          <div class="container">
            <div class="row">
              <div class="col-xs-12 col-sm-7 col-sm-push-5">
                <h2 class="title">一键实时查车</h2>
                <div class="txt">
                  “一键查车”、“实时站牌”、“实时公交地图”、“动态换乘规划”，简单且强大的实用查车神器，一键即可以地图或者列表模式查看离你最近的站点线路动态信息，精准实时，操作简单，信息直观，各年龄段的市民都能一用就会。
                </div>
              </div>
              <div class="bg_carousel col-xs-12 col-sm-5 col-sm-pull-7">
                <div class="carousel slide cs_carousel">
                  <div class="carousel-inner">
                    <div class="item active">
                      <img
                        src="../../assets/images/index-carousel-01-01.png"
                        alt
                      />
                    </div>
                    <div class="item">
                      <img
                        src="../../assets/images/index-carousel-01-02.png"
                        alt
                      />
                    </div>
                    <div class="item">
                      <img
                        src="../../assets/images/index-carousel-01-03.png"
                        alt
                      />
                    </div>
                    <div class="item">
                      <img
                        src="../../assets/images/index-carousel-01-04.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="container">
            <div class="row">
              <div class="col-xs-12 col-sm-7">
                <h2 class="title">多元化智能公交</h2>
                <div class="txt">
                  提供定制公交、网约拼巴、企业专线、扫码乘车、实名乘车追溯和各种车型的包车租车服务。定制公交线路可由市民通过“掌上公交”APP提出乘车需求，公交公司根据需求和客流分析设计出公交线路。实现“1
                  人 1
                  座、电子车票、定时定点、扫码乘车、快速直达”的多元化公交服务。
                </div>
              </div>
              <div class="col-xs-12 col-sm-5">
                <div class="carousel slide cs_carousel">
                  <div class="carousel-inner">
                    <div class="item active">
                      <img
                        src="../../assets/images/index-carousel-02-01.png"
                        alt
                      />
                    </div>
                    <div class="item">
                      <img
                        src="../../assets/images/index-carousel-02-02.png"
                        alt
                      />
                    </div>
                    <!-- <div class="item">
                      <img
                        src="../../assets/images/index-carousel-02-03.png"
                        alt
                      />
                    </div> -->
                    <div class="item">
                      <img
                        src="../../assets/images/index-carousel-02-04.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="container">
            <div class="row">
              <div class="col-xs-12 col-sm-7 col-sm-push-5">
                <h2 class="title">微循环响应式公交(微公交)</h2>
                <div class="txt">
                  微公交平台充分利用移动互联网+公交出行模式，推出“区域型动态公交”服务，能够深入覆盖城市郊区，园区，社区，片区。乘客根据个人出行需求，动态匹配线路，实现“动态需求”、“动态发车”、“动态线路”，乘客端提供“即时约车”、“预约叫”、“代叫”模式，公交可根据实际情况，配置车辆，分配任务订单，区域管理，站点管理等功能。
                </div>
              </div>
              <div class="bg_carousel col-xs-12 col-sm-5 col-sm-pull-7">
                <div class="carousel slide cs_carousel">
                  <div class="carousel-inner">
                    <div class="item active">
                      <img src="../../assets/images/wgj01.png" alt />
                    </div>
                    <div class="item">
                      <img src="../../assets/images/wgj02.png" alt />
                    </div>
                    <div class="item">
                      <img src="../../assets/images/wgj03.png" alt />
                    </div>
                    <div class="item">
                      <img src="../../assets/images/wgj04.png" alt />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="container">
            <div class="row">
              <div class="col-xs-12 col-sm-7 ">
                <h2 class="title">扫码乘车</h2>
                <div class="txt">
                  掌上公交付款码，支持银联二维码扫码乘公交、地铁，即开即用，避免了没有公交卡和零钱时的乘车问题，比起传统的交通卡乘车更为方便，只要有手机就能坐车，享受便捷升级的智能生活。
                </div>
              </div>
              <div class="col-xs-12 col-sm-5">
                <div class="carousel slide cs_carousel">
                  <div class="carousel-inner">
                    <div class="item active">
                      <img
                        src="../../assets/images/index-carousel-03-01.png"
                        alt
                      />
                    </div>
                    <div class="item">
                      <img
                        src="../../assets/images/index-carousel-03-02.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="container">
            <div class="row">
              <div class="col-xs-12 col-sm-7 col-sm-push-5">
                <h2 class="title">站台巡检</h2>
                <div class="txt">
                  为配合城市公交站点管理及维护的工作，掌上公交推出了“公交站台巡检系统”，工作人员或市民使用微信搜索小程序进入系统，可扫描公交站牌上张贴的二维码或在地图上选择站点，即可上报该站点问题。公交可根据实际情况，配置巡检报修、站点采集、站点清洁、站点维修等功能。
                </div>
              </div>
              <div class="bg_carousel col-xs-12 col-sm-5 col-sm-pull-7">
                <div class="carousel slide cs_carousel">
                  <div class="carousel-inner">
                    <div class="item active">
                      <img
                        src="../../assets/images/index-carousel-04-01.png"
                        alt
                      />
                    </div>
                    <div class="item">
                      <img
                        src="../../assets/images/index-carousel-04-02.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="container">
            <div class="row">
              <div class="col-xs-12 col-sm-7">
                <h2 class="title">地铁出口换乘码</h2>
                <div class="txt">
                  查看途经地铁线路信息：打开支付宝和微信扫描换乘码，小程序内可查看途经线路的站点、起步票价、全网最高票价，站点营运时间等详细信息。展示地铁出口所对应的出口方向及途经的公交站点。查看公交站点的途经线路，实时了解详细信息
                </div>
              </div>
              <div class="col-xs-12 col-sm-5">
                <div class="carousel slide cs_carousel">
                  <div class="carousel-inner">
                    <div class="item active">
                      <img
                        src="../../assets/images/index-carousel-05-01.png"
                        alt
                      />
                    </div>
                    <div class="item">
                      <img
                        src="../../assets/images/index-carousel-05-02.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="container">
            <div class="row">
              <div class="col-xs-12">
                <h2 class="title"><span>“掌上”</span> 乘公交 出行更美好</h2>
                <div class="txt">
                  “掌上公交”全方位接入了全国400多个城市公交实时数据资源，累计服务了超过2亿用户，开创智能公交新模式。实现了多种功能，
                  包括实时站牌、实时换乘、实时地图、乘车提醒等功能，有效地提高了用户出行效率和出行体验。
                </div>
                <div class="video">
                  <video
                    id="videoplay"
                    ref="video"
                    @click="play"
                    poster="../../assets/video/yangshi.png"
                    webkit-playsinline="true"
                    playsinline="true"
                    src="../../assets/video/yangshi.mp4"
                  ></video>

                  <div v-if="!pause" class="video_btn" @click="play">
                    <img src="../../assets/images/video-start.png" alt />
                  </div>
                </div>
                <div class="video">
                  <button class="more-vidoe" @click="jumpMedia">
                    <span>
                      <a href="#video-box">更多视频</a>
                    </span>
                    <i class="el-icon-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <footer-box ref="footer"></footer-box>
  </div>
  <!-- <div class="container-fluid">

  </div>-->
</template>

<script>
import FooterBox from "components/footer/footer";
import HeaderBox from "components/header/header";
import ShareModal from "components/sharemodal/sharemodal";
import wx from "weixin-js-sdk";
// import VConsole from "vconsole";
// let vConsole = new VConsole();

export default {
  components: {
    HeaderBox,
    FooterBox,
    ShareModal
    // WxOpenLaunchWeapp,
  },
  data() {
    return {
      slide1: 0,
      slide2: 0,
      pause: false,
      curConfig: {},
      isBrowser: false,
      appId: "wxb9e506ed4f66afc4",
      showWx: false
    };
  },

  methods: {
    jumpAppStore() {
      this.$refs.footer.jumpAppStore();
    },
    jumpAndroid() {
      this.$refs.footer.jumpAndroid();
    },

    jumpHarmonyOS() {
      this.$refs.footer.jumpHarmonyOS();
    },
    downZsgj() {
      if (this.curConfig.isIOS) {
        this.$refs.footer.jumpAppStore();
      } else if (this.curConfig.isAndroid) {
        this.$refs.footer.jumpAndroid();
      } else if (this.curConfig.isHarmonyOS) {
        this.$refs.footer.jumpHarmonyOS();
      }
    },
    openWechat() {
      let url = window.location.href;
      if (url.indexOf("/home") > -1) {
        var btn = document.getElementById("launch-btn");
        // console.log(btn);
        btn.addEventListener("launch", function(e) {
          console.log("success");
        });
        btn.addEventListener("error", function(e) {
          alert("小程序打开失败");
          console.log("fail", e.detail);
        });
      } else {
        console.log("click");
        window.location.href = "weixin://dl/business/?t=iLO19IFhaFj";
      }
    },
    async loadWechat() {
      const res = await this.$wxHttp.get(`ApiData.do`, {
        CMD: 204,
        kkk: 58581313,
        signurl: encodeURIComponent(window.location.href.split("#")[0])
      });
      let wxRes = res.data;
      // console.log(wxRes, "wxRes");
      // this.appId = wxRes.appid;

      try {
        wx.config({
          debug: false, // 开启调试模式
          appId: wxRes.appid, // 必填，公众号的唯一标识
          timestamp: wxRes.timestamp, // 必填，生成签名的时间戳
          nonceStr: wxRes.nonceStr, // 必填，生成签名的随机串
          signature: wxRes.signature, // 必填，签名
          jsApiList: ["wx-open-launch-weapp"], // 必填，需要使用的JS接口列表
          openTagList: ["wx-open-launch-weapp"] // 打开小程序
        });
        let _this = this;
        wx.ready(() => {
          wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              console.log(res, "微信小程序环境");
            } else {
              console.log("普通 H5 环境（可能是聊天会话或扫码）");
            }
          });
        });
        wx.error(function(res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
          // console.log(res, "error");
        });
      } catch (error) {
        console.log(error, "wx error");
      }
    },

    play() {
      const video = this.$refs.video;
      this.pause = video.paused;
      if (this.pause) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
    },
    jumpMedia() {
      this.$router.push({
        path: "/media"
      });
    }
  },
  mounted() {
    // console.log(this.$route.path);
    // window.location.replace(window.location.href);

    this.$nextTick(() => {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    });
    this.curConfig = this.$browser();
    console.log(this.curConfig, "curConfig");
    $(".cs_carousel").carousel();
    // 推广的cityName 所属城市，company所属公司,pid 图片位置，type,访问来源
    const cityName = this.$route.query.cityName;
    const company = this.$route.query.company;
    const pid = this.$route.query.pid;
    const type = this.$route.query.type;

    if (pid || cityName || company) {
      try {
        // 友盟埋点
        this.$czc.push(["_setCustomVar", "城市名称", cityName, 0]);
        this.$czc.push(["_setCustomVar", "公交公司名称", company, 0]);
        this.$czc.push(["_setCustomVar", "图片ID", pid, 0]);
        this.$czc.push(["_setCustomVar", "访问来源", type, 0]);
        // 百度埋点
        this.$hmt.push(["_setCustomVar", 1, "城市名称", cityName, 3]);
        this.$hmt.push(["_setCustomVar", 1, "公交公司名称", company, 3]);
        this.$hmt.push(["_setCustomVar", 1, "图片ID", pid, 3]);
        this.$hmt.push(["_setCustomVar", 1, "访问来源", type, 3]);
      } catch (e) {
        console.log("error");
      }
    }
    this.showWx = this.$route.query.showWx == 0 ? true : false;

    this.loadWechat();
    // if (this.$route.query.openWechat == 1) {
    //   let vConsole = new VConsole();
    // }
  }
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>

<style lang="less">
@media (min-width: 540px) {
  .carousel-inner {
    .carousel-pic {
      img {
        width: 300px !important /*no*/;
        height: 463px /*no*/;
        margin: auto /*no*/;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue